import { handleActions } from 'redux-actions';

export default handleActions(
	{
		FETCH_IG_MEDIA_FULFILLED: (state, action) => ({
			...state,

			ig: {
				list: action.payload.list,
				data: {
					...state.ig.data,
					...action.payload.data,
				},
			},
		}),
	},
	{
		ig: {
			list: [],
			data: {},
		},
	},
);



// WEBPACK FOOTER //
// ./src/reducers/social.js